import type { FC, PropsWithChildren } from "react";
import { Link as DomLink } from "react-router";

import type { GlobalRoute } from "../../core/router/types/routerTypes";

type LinkProps = Readonly<{ route: GlobalRoute; className?: string; to: string; showNotAllowed?: boolean }> & PropsWithChildren;

/**
 * Do not render link if me has no required roles to do this
 *
 * @param route - whole route object
 * @param to - path to where redirect, route.fillPathParams(pathParams) could be used but this is type stronger
 * @param children
 * @param className
 */
export const Link: FC<LinkProps> = ({ to, children, className }) => {
    return (
        <DomLink to={to} className={className}>
            {children}
        </DomLink>
    );
};
